import React, { useEffect, useState } from "react";
import { UserDashboardAPI } from "../../api/master/indes";
import { useParams, useLocation } from "react-router-dom";
import { BASE_URL_IMG } from "../../assets/constants";
import { useNavigate } from "react-router-dom";

import {
    Card,
    CardBody,
    Row,
    Col,
    Badge,
    Table,
} from "reactstrap";


const UserDashboard = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const { id: routeId } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const userId = location.state?.id || location.state?.userId || routeId;

    // Fetch API
    const getDashboard = async () => {
        if (!userId) {
            console.error("Missing userId for UserDashboard");
            setLoading(false);
            return;
        }

        try {
            const payload = {
                userId,
            };

            console.log("UserDashboard payload", payload);
            const res = await UserDashboardAPI(payload);

            console.log("API", res);

            const apiData = res?.data?.data || res?.data;
            setData(apiData);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getDashboard();
    }, []);

    if (loading) return <p className="p-4">Loading...</p>;

    const { user, totals, recent } = data || {};

    return (
        <div className="container-fluid p-4">
            <h3 className="mb-4 mt-5">User Details</h3>

            {/* User Info */}
            <Card className="mb-4">
                <CardBody>
                    <Row>
                        <Col md="4" className="d-flex gap-3">
                            <img
                                src={
                                    user?.image
                                        ? `${BASE_URL_IMG}${user.image}`
                                        : "https://via.placeholder.com/80"
                                }
                                alt="user"
                                className="rounded-circle"
                                width={100}
                                height={100}
                            />
                            <div>
                                <h5>
                                    {user?.name}{" "}
                                    <Badge color="success">Active</Badge>
                                </h5>
                                <p className="mb-1">User ID: {user?.registration_num}</p>
                                <p className="mb-1">{data?.user?.email}</p>
                                <p className="mb-0">{data?.user?.mobile}</p>
                            </div>
                        </Col>

                        <Col md="4">
                            <p><strong>DOB:</strong> {data?.user?.dob}</p>
                            <p><strong>Gender:</strong> {data?.user?.gender}</p>
                            <p><strong>Location:</strong> {user?.city}, {user?.state}</p>
                        </Col>

                        <Col md="4">
                            <p><strong>Pincode:</strong> {user?.pincode}</p>
                        </Col>
                    </Row>
                </CardBody>
            </Card>

            {/* Stats */}
            <Row className="mb-4">
                <Col md="3">
                    <Card
                        onClick={() =>
                            navigate("/pharmacy-user-orders", {
                                state: { userId: userId },
                            })
                        }
                        style={{ cursor: "pointer" }}
                    >
                        <CardBody>
                            <h6>Pharmacy Orders</h6>
                            <h4>{totals?.pharmacy?.totalOrders}</h4>
                            <p className="text-muted">
                                ₹{totals?.pharmacy?.totalSpend}
                            </p>
                        </CardBody>
                    </Card>
                </Col>

                <Col md="3">
                    <Card
                        onClick={() =>
                            navigate("/lab-user-orders", {
                                state: { userId: userId },
                            })
                        }
                        style={{ cursor: "pointer" }}
                    >
                        <CardBody>
                            <h6>Diagnostics</h6>
                            <h4>{totals?.lab?.totalOrders}</h4>
                            <p className="text-muted">
                                ₹{totals?.lab?.totalSpend}
                            </p>
                        </CardBody>
                    </Card>
                </Col>

                <Col md="3">
                    <Card
                        onClick={() =>
                            navigate("/user-consultations", {
                                state: { userId: userId },
                            })
                        }
                        style={{ cursor: "pointer" }}
                    >
                        <CardBody>
                            <h6>Consultations</h6>
                            <h4>{totals?.consult?.totalBookings}</h4>
                            <p className="text-muted">
                                ₹{totals?.consult?.totalSpend}
                            </p>
                        </CardBody>
                    </Card>
                </Col>

                <Col md="3">
                    <Card>
                        <CardBody>
                            <h6>Total Spent</h6>
                            <h4>₹{totals?.overallSpend}</h4>
                            <p className="text-muted">All Time</p>
                        </CardBody>
                    </Card>
                </Col>
            </Row>

            {/* Recent Orders (Pharmacy + Lab Combined) */}
            <Card className="mb-4">
                <CardBody>
                    <h5 className="mb-3">Recent Orders</h5>
                    <Table responsive>
                        <thead>
                            <tr>
                                <th>Order ID</th>
                                <th>Type</th>
                                <th>Amount</th>
                                <th>Status</th>
                                <th>Date</th>
                            </tr>
                        </thead>

                        <tbody>
                            {[...(recent?.pharmacyOrders || []), ...(recent?.labOrders || [])]
                                .slice(0, 5)
                                .map((item, index) => (
                                    <tr key={index}>
                                        <td>{item.orderNum}</td>
                                        <td>{item.finalAmount ? "Lab" : "Pharmacy"}</td>
                                        <td>₹{item.totalAmount || item.finalAmount}</td>
                                        <td>
                                            <Badge
                                                color={
                                                    item.status === "pending"
                                                        ? "warning"
                                                        : item.status === "processing"
                                                            ? "info"
                                                            : "success"
                                                }
                                            >
                                                {item.status}
                                            </Badge>
                                        </td>
                                        <td>
                                            {new Date(item.createdAt).toLocaleDateString()}
                                        </td>
                                    </tr>
                                ))}
                        </tbody>
                    </Table>
                </CardBody>
            </Card>

            {/* Recent Consult Payments */}
            <Card>
                <CardBody>
                    <h5 className="mb-3">Recent Consultations</h5>
                    <Table responsive>
                        <thead>
                            <tr>
                                <th>Appointment</th>
                                <th>Patient</th>
                                <th>Fee</th>
                                <th>Date</th>
                            </tr>
                        </thead>

                        <tbody>
                            {recent?.consultBookings?.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.appointment_num}</td>
                                    <td>{item.patientName}</td>
                                    <td>₹{item.fee}</td>
                                    <td>
                                        {new Date(item.date).toLocaleDateString()}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </CardBody>
            </Card>
        </div>
    );
};

export default UserDashboard;